// extracted by mini-css-extract-plugin
export default {"card":"Card_brown_card__xbXaP"};